var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/DoubleChevron-Small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1746 9.87962C9.38426 10.0593 9.69991 10.035 9.87962 9.82539C10.0593 9.61572 10.035 9.30007 9.82539 9.12036L6.32539 6.12036C6.13814 5.95987 5.86184 5.95987 5.6746 6.12036L2.1746 9.12036C1.96493 9.30007 1.94065 9.61572 2.12036 9.82539C2.30007 10.0351 2.61572 10.0593 2.82539 9.87962L5.99999 7.15853L9.1746 9.87962ZM9.17459 5.87962C9.38426 6.05933 9.69991 6.03505 9.87962 5.82539C10.0593 5.61572 10.035 5.30007 9.82539 5.12036L6.32539 2.12036C6.13814 1.95987 5.86184 1.95987 5.67459 2.12036L2.17459 5.12036C1.96493 5.30007 1.94065 5.61572 2.12036 5.82539C2.30007 6.03505 2.61572 6.05933 2.82539 5.87962L5.99999 3.15853L9.17459 5.87962Z",
    fill: "#3E3E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevron);
export default __webpack_public_path__ + "static/media/DoubleChevron.64fbca2eec4860a0ae19d946716d8402.svg";
export { ForwardRef as ReactComponent };